// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___PPheN","root__mobile":"style-module__root__mobile___EfhSz","mainLogo":"style-module__mainLogo___PoSeb","info":"style-module__info___O9EXC","info__title":"style-module__info__title___SvOUu","info__description":"style-module__info__description___kIB41"};
    if(module.hot) {
      // 1729151198218
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  